import { useState } from 'react';
import { queryBinNoAuth } from "../../../../../api/requests/payment-requests";
import { resolveBankLogo, resolveCardSchemaLogo } from '../../../../../utils/bankLogo';

// linkId: ödeme linkinin token'ı/id'si. Kart markası sorgusu, ödeme anındaki sorguyla
// AYNI sağlayıcıya gitmeli; yoksa iki kaynak farklı marka döndürürse ödeme
// "Kart türü hatalı" ile reddedilir.
export default function useBinLookup({ setCardVisual, setSelectedInstallment, linkId }) {
    const [lastBin, setLastBin] = useState(null);
    const [binQueryStatus, setBinQueryStatus] = useState('');
    const [paytrError, setPaytrError] = useState('');
    const [detectedCardBrand, setDetectedCardBrand] = useState(null);

    const clearBin = () => {
        setCardVisual(prev => ({ ...prev, brand: '', type: '', bank: '', schema: '', bankLogo: '', cardLogo: '' }));
        setBinQueryStatus('');
        setPaytrError('');
        setDetectedCardBrand(null);
        setSelectedInstallment({ count: 1, commission: 0 });
    };

    const queryBIN = async (bin) => {
        try {
            setBinQueryStatus('loading');
            setPaytrError('');
            const res = await queryBinNoAuth(bin, linkId);
            const wrapper = await res.json();

            if (res.ok && wrapper.statusCode === 200 && wrapper.data.status === 'success') {
                const data = wrapper.data;
                const brand = (data.brand || data.schema || '').toUpperCase();
                setDetectedCardBrand(brand);

                setCardVisual(prev => ({
                    ...prev,
                    bank: data.bank || '',
                    brand,
                    type: (data.cardType || '').toUpperCase(),
                    schema: (data.schema || '').toUpperCase(),
                    bankLogo: resolveBankLogo(data.bank),
                    cardLogo: resolveCardSchemaLogo(data.schema)
                }));

                setSelectedInstallment({ count: 1, commission: 0 });
                setBinQueryStatus('success');
            } else {
                throw new Error(wrapper.message || 'BIN lookup failed');
            }
        } catch (err) {
            setBinQueryStatus('error');
            setPaytrError(err.message);
        }
    };

    const onBinCandidate = (maybeBin) => {
        if (!maybeBin) {
            if (lastBin !== null) setLastBin(null);
            clearBin();
            return;
        }
        if (maybeBin !== lastBin) {
            setLastBin(maybeBin);
            queryBIN(maybeBin);
        }
    };

    return { lastBin, binQueryStatus, paytrError, detectedCardBrand, onBinCandidate, clearBin };
}